import {Component, Input, OnInit,  Output, EventEmitter } from '@angular/core';
import { DEFAULT_STEP,  formatTwoDigitTimeValue,  LIMIT_TIMES,  MERIDIANS } from '../date-time-utils';

type MatSizeType = 'sm' | 'lg' | 'md';

const MatSizeClassMap = {
  sm: 'mat-size-sm',
  lg: 'mat-size-lg',
  md: 'mat-size-md',
};

const MatMeridianType = {
  CIRCLE: 'timepicker-meridian-circle',
  SQUARE: 'timepicker-meridian-square',
}

@Component({
  selector: 'nw-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
})
export class NewellTimePickerComponent implements OnInit {
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;

  @Input() stepHour: number = DEFAULT_STEP;
  @Input() stepMinute: number = DEFAULT_STEP;
  @Input() stepSecond: number = DEFAULT_STEP;

  @Input() showSeconds = false;
  @Input() enableMeridian: boolean = false;
  @Input() meridianBtn: 'CIRCLE' | 'SQUARE' = 'SQUARE';
  @Input() size: MatSizeType;

  @Input() min: Date;
  @Input() max: Date;

  @Input() value: Date = new Date();
  @Output() valueChange = new EventEmitter<Date>();
  @Output() change = new EventEmitter<Date>();

  public hour: string = '00';
  public minute: string = '00';
  public second: string = '00';

  public meridian: string = MERIDIANS.AM;
  public limits = LIMIT_TIMES;

  public sizeClass: string;
  public meridianType: string;

  constructor() {}

  ngOnInit(): void {
    this.sizeClass = MatSizeClassMap[this.size];
    this.meridianType = MatMeridianType[this.meridianBtn];
  }

  ngOnChanges() {
    this.updateTime();
  }

  updateTime() {
    let _hours = this.value.getHours();
    this.meridian = _hours >= 12 ? MERIDIANS.PM : MERIDIANS.AM;

    if (this.enableMeridian && _hours === 0) {
      _hours = 12;
    } else if (this.enableMeridian && _hours > 12) {
      _hours = _hours - 12;
    }

    this.hour = formatTwoDigitTimeValue(_hours);
    this.minute = formatTwoDigitTimeValue(this.value.getMinutes());
    this.second = formatTwoDigitTimeValue(this.value.getSeconds());
    this.valueChange.emit(this.value);
  }

  public toggleMeridian() {
    this.meridian =
      this.meridian === MERIDIANS.AM ? MERIDIANS.PM : MERIDIANS.AM;
    const _hours = this.value.getHours();

    if (this.meridian === MERIDIANS.AM) {
      this.meridian = MERIDIANS.PM;
      this.value.setHours(_hours + 12);
    } else if (this.meridian === MERIDIANS.PM) {
      this.meridian = MERIDIANS.AM;
      this.value.setHours(_hours - 12);
    }

    this.updateTime();
  }

  public increaseHour(step = 1) {
    const _hours = this.value.getHours();
    this.value.setHours(_hours + step);
    this.updateTime();
  }

  public decreaseHour(step = 1) {
    const _hours = this.value.getHours();
    this.value.setHours(_hours - step);
    this.updateTime();
  }

  public increaseMinute(step = 1) {
    const _minutes = this.value.getMinutes();
    this.value.setMinutes(_minutes + step);
    this.updateTime();
  }

  public decreaseMinute(step = 1) {
    const _minutes = this.value.getMinutes();
    this.value.setMinutes(_minutes - step);
    this.updateTime();
  }

  public increaseSecond(step = 1) {
    const _seconds = this.value.getSeconds();
    this.value.setSeconds(_seconds + step);
    this.updateTime();
  }

  public decreaseSecond(step = 1) {
    const _seconds = this.value.getSeconds();
    this.value.setSeconds(_seconds - step);
    this.updateTime();
  }
}
